// Task 1
const taskOneContainer = document.getElementById("taskOneContainer");
let index = 0;
const id = setInterval(() => {
    if (index == 4) {
        clearInterval(id);
    }
    taskOneContainer.innerHTML = "";
    const text = document.createElement("p");
    index++;
    text.textContent = "Message #" + index;
    taskOneContainer.append(text);
}, 1000);


// Task 2
const taskTwoContainer = document.getElementById("taskTwoContainer");
const sqr = document.createElement("div");
const id2 = setInterval(() => {
    let rScale = Math.random() * 1.1;
    let r1 = Math.random() * 255;
    let r2 = Math.random() * 255;
    let r3 = Math.random() * 255;
    sqr.style.backgroundColor = "rgb(" + r1 + "," + r2 + "," + r3 + ")";
    sqr.style.width = "200px";
    sqr.style.height = "200px";
    sqr.style.scale = rScale;
    taskTwoContainer.append(sqr)
}, 2000);



// Task 3
const taskThreeContainer = document.getElementById("taskThreeContainer");
const el1 = document.getElementById("el1");
const el2 = document.getElementById("el2");
const el3 = document.getElementById("el3");
const p = document.createElement("p");
p.style.fontSize = "16px";
const headText = document.createElement("p");
headText.textContent = "У вас 10 секунд, щоб зробити 200+ натискань"
headText.style.fontSize = "20px";

function checkClicked() {
    if (clicked >= 200) {
        alert("Перемога. Натискань 200");
        return true
    }
}
let clicked = 0;
el1.addEventListener("click", e => {
        e.preventDefault();
        checkClicked()
        clicked++;
        p.textContent = clicked;
    });
    el2.addEventListener("click", e => {
        e.preventDefault();
        checkClicked();
        clicked++;
        p.textContent = clicked;
    });
    el3.addEventListener("click", e => {
        e.preventDefault();
        checkClicked();
        clicked++;
        p.textContent = clicked;
    });

taskThreeContainer.prepend(p);
const id3 = setInterval(() => {
    clicked = 0
}, 10000);


// Task 4
const enteredTime = Number(prompt("Час?:"));
setTimeout(() => {
    alert("Timer(" + enteredTime + " second)");
}, enteredTime*1000)